import React, { useState, useEffect, useRef } from "react";
import { Input } from "reactstrap";

const DebouncedSearchInput = ({
  value = "",
  onChange,
  delay = 300,
  placeholder = "Search...",
  style = {},
  className = "",
  ...props
}) => {
  const [searchTerm, setSearchTerm] = useState(value || "");
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  // Sync internal state if external value changes (e.g., reset filters or chip removal)
  useEffect(() => {
    setSearchTerm(value || "");
  }, [value]);

  useEffect(() => {
    // If searchTerm is already in sync with prop value, do not trigger timer
    if (searchTerm === (value || "")) return;

    const handler = setTimeout(() => {
      if (onChangeRef.current) {
        onChangeRef.current(searchTerm);
      }
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm, delay, value]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (onChangeRef.current) {
        onChangeRef.current(searchTerm);
      }
    }
  };

  return (
    <Input
      {...props}
      value={searchTerm}
      placeholder={placeholder}
      style={style}
      className={className}
      onChange={(e) => setSearchTerm(e.target.value)}
      onKeyDown={handleKeyDown}
    />
  );
};

export default DebouncedSearchInput;
